// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_i18n.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_cmw";

export interface StcsI18nLabelMap {
  label_map: { [key: string]: string };
}

export interface StcsI18nLabelMap_LabelMapEntry {
  key: string;
  value: string;
}

function createBaseStcsI18nLabelMap(): StcsI18nLabelMap {
  return { label_map: {} };
}

export const StcsI18nLabelMap: MessageFns<StcsI18nLabelMap> = {
  encode(message: StcsI18nLabelMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.label_map).forEach(([key, value]) => {
      StcsI18nLabelMap_LabelMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsI18nLabelMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsI18nLabelMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsI18nLabelMap_LabelMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.label_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsI18nLabelMap {
    return {
      label_map: isObject(object.label_map)
        ? Object.entries(object.label_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsI18nLabelMap): unknown {
    const obj: any = {};
    if (message.label_map) {
      const entries = Object.entries(message.label_map);
      if (entries.length > 0) {
        obj.label_map = {};
        entries.forEach(([k, v]) => {
          obj.label_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsI18nLabelMap>, I>>(base?: I): StcsI18nLabelMap {
    return StcsI18nLabelMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsI18nLabelMap>, I>>(object: I): StcsI18nLabelMap {
    const message = createBaseStcsI18nLabelMap();
    message.label_map = Object.entries(object.label_map ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsI18nLabelMap_LabelMapEntry(): StcsI18nLabelMap_LabelMapEntry {
  return { key: "", value: "" };
}

export const StcsI18nLabelMap_LabelMapEntry: MessageFns<StcsI18nLabelMap_LabelMapEntry> = {
  encode(message: StcsI18nLabelMap_LabelMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsI18nLabelMap_LabelMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsI18nLabelMap_LabelMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsI18nLabelMap_LabelMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: StcsI18nLabelMap_LabelMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsI18nLabelMap_LabelMapEntry>, I>>(base?: I): StcsI18nLabelMap_LabelMapEntry {
    return StcsI18nLabelMap_LabelMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsI18nLabelMap_LabelMapEntry>, I>>(
    object: I,
  ): StcsI18nLabelMap_LabelMapEntry {
    const message = createBaseStcsI18nLabelMap_LabelMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
